<template>

</template>

<script>
export default {
	"name": "empty",
	"props": ["value"],
	"data"() {
		return {
			"_id": ""
		}
	},
	"mounted"() {

	},
	"methods": {},
	"watch": {}
}
</script>

<style scoped>

</style>